var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVaultFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 73,
    viewBox: "0 0 58 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3335 18.5H26.5835L21.7502 12.5H9.66683C7.0085 12.5 4.8335 15.2 4.8335 18.5V30.5H53.1668V24.5C53.1668 21.2 50.9918 18.5 48.3335 18.5Z",
    fill: "#0056CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3335 18.5H9.66683C7.0085 18.5 4.8335 21.2 4.8335 24.5V54.5C4.8335 57.8 7.0085 60.5 9.66683 60.5H48.3335C50.9918 60.5 53.1668 57.8 53.1668 54.5V24.5C53.1668 21.2 50.9918 18.5 48.3335 18.5Z",
    fill: "#C2DCFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultFolder);
export default __webpack_public_path__ + "static/media/vault-folder.ce6d85a0.svg";
export { ForwardRef as ReactComponent };